import { ProductsType } from 'src/constants/products';
import { PATH_DASHBOARD } from 'src/constants/spa-routes';

/**
 * URL of a project-creation step. Only customer projects go through the multi-step flow;
 * for every other project type the flow ends on the project page.
 */
export const getCreateProjectStepPath = (
  projectId: number | string,
  step: number,
  projectType: string,
): string =>
  projectType === ProductsType.customer
    ? `${PATH_DASHBOARD.PROJECTS}/${projectId}/new/${step}?type=${projectType}`
    : `${PATH_DASHBOARD.PROJECTS}/${projectId}?type=${projectType}`;
